// extracted by mini-css-extract-plugin
export default {"radio":"DeleteModalView_radio__QM9Fj","feedback":"DeleteModalView_feedback__TGirF"};